

















































































































import Vue from 'vue'
import { FeedbackResultsModel } from '@/models/FeedbackResultsModel'
import { FeedbackRequestOwnerModel } from '@/models/FeedbackRequestOwnerModel'
import { FeedbackAnalysisModel } from '@/models/FeedbackAnalysisModel'
import ShareLinkTextField from '@/components/ShareLinkTextField.vue'

export default Vue.extend({
  name: 'FeedbackResults',
  components: {
    ShareLinkTextField
  },
  props: {},
  data: () => ({
    results: new FeedbackResultsModel(),
    expandedPanels: [] as number[],
    loading: false,
    requestOwnerModel: {
      id: '',
      sharedId: '',
      sharedUrl: '',
      feedbackTemplateId: '',
      ownersName: '',
      ownersEmail: ''
    } as FeedbackRequestOwnerModel
  }),
  methods: {
    clickElement (id: string) {
      let elem = document.getElementById(id)
      if (elem) {
        elem.click()
      }
    }
  },
  async mounted () {
    this.$emit('sub-title-change', 'Feedback Results')
    let feedbackRequestId = this.$router.currentRoute.params['feedbackRequestId']
    this.loading = true
    Promise.all([
      await this.$store.dispatch('getFeedbackRequestById', feedbackRequestId),
      await this.$store.dispatch('getFeedbackRequestAnalysis', feedbackRequestId)
    ])
      .then((results: any[]) => {
        let requestOwnerModel = results[0] as FeedbackRequestOwnerModel
        let resultsModel = results[1] as FeedbackResultsModel
        if (resultsModel) {
          this.results = resultsModel
        }
        if (requestOwnerModel) {
          this.requestOwnerModel = requestOwnerModel
        }
        this.$set(this.requestOwnerModel, 'sharedUrl', this.requestOwnerModel.sharedUrl)

        this.expandedPanels = []
        if (this.results && this.results.feedbackAnalysis && this.results.feedbackAnalysis.questionAnswers) {
          for (var i = 0; i < this.results.feedbackAnalysis.questionAnswers.length; i++) {
            this.expandedPanels.push(i)
          }
        }
        this.loading = false

        return Promise.resolve()
      })
  }
})
